var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            !_vm.isUsePeriodRate
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_ChargeRate"),
                      name: "chargeRate",
                      lazy: true,
                      no: "chargeRate"
                    }
                  },
                  [_c("charge-rate")],
                  1
                )
              : _vm._e(),
            _vm.isUsePeriodRate
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.chargeRateLable,
                      name: "ratePeriod",
                      lazy: true,
                      no: "ratePeriod"
                    }
                  },
                  [_c("rate-period", { attrs: { "hq-rate": true } })],
                  1
                )
              : _vm._e(),
            _vm.isUsePeriodRate &&
            _vm.isBranchRate &&
            _vm.$checkPermission(["tab_SMRate_officeRate"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_BranchRate"),
                      name: "ratePeriodBranch",
                      lazy: true,
                      no: "ratePeriodBranch"
                    }
                  },
                  [_c("rate-period", { attrs: { "hq-rate": false } })],
                  1
                )
              : _vm._e(),
            _vm.isSaveBillRate
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_BillingRate"),
                      name: "billingRate",
                      lazy: true,
                      no: "billingRate"
                    }
                  },
                  [_c("billing-rate")],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }